import slider from "../components/slider";

slider("carousel-slider", {
    type: "carousel",
    startAt: 0,
    perView: 4,
    peek: {
        before: 0,
        after: 95
    },
    breakpoints: {
        1000: {
            perView: 3
        },
        800: {
            perView: 2
        },
        480: {
            perView: 1,
            peek: {
                before: 75,
                after: 75
            }
        }
    }
});

const slides = document.querySelectorAll(".carousel-slide");

slides.forEach(slide => {
    let image = slide.querySelector(".carousel-slide__image");

    if (image) {
        let originalSrc = image.src;
        let hoverSrc = image.dataset.hover;

        if (hoverSrc) {
            slide.addEventListener("mouseover", (e) => {
                image.src = hoverSrc;
            });

            slide.addEventListener("mouseout", (e) => {
                image.src = originalSrc;
            });
        }
    }
});